import {Router} from '@angular/router';
import {ActionSheetController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {Component, Input, OnInit} from '@angular/core';
import {ProductModel} from './../../models/wardrobe.model';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';
import {WardrobeService} from './../../services/wardrobe.service';
import {ErrorHandlerService} from 'src/app/services/error-handler.service';
import {PaginatedResponse} from 'src/app/models/paginated-response.model';

@Component({
  selector: 'shc-wardrobe-item',
  templateUrl: './wardrobe-item.component.html',
  styleUrls: ['./wardrobe-item.component.scss'],
})
export class WardrobeItemComponent implements OnInit {
  @Input() products: PaginatedResponse<ProductModel>;

  constructor(
    private actionSheetController: ActionSheetController,
    private router: Router,
    private wardrobeService: WardrobeService,
    private errorService: ErrorHandlerService,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
  }

  async presentActionSheet(ev, id: number) {
    ev.stopPropagation();
    const actionSheet = await this.actionSheetController.create({
      mode: 'md',
      cssClass: 'edit-wardrobe-actionsheet',
      buttons: [
        {
          text: this.translate.instant(marker('Item.Edit')),
          cssClass: 'edit-product',
          handler: () => {
            this.routeToEditProduct(id);
          }
        }, {
          text: this.translate.instant(marker('Item.DeleteText')),
          cssClass: 'delete-product',
          handler: () => {
            this.deleteWardrobe(id);
          }
        }
      ]
    });
    await actionSheet.present();
  }

  routeToEditProduct(id: number) {
    this.router.navigate(['wardrobe', 'edit', id]);
  }

  deleteWardrobe(id: number) {
    this.wardrobeService.deleteProduct(id).subscribe(res => {
      this.products.data = this.products.data.filter(p => p.id !== id);
      this.errorService.showToast(this.translate.instant(marker('Item.Delete.Success')));
    }, error => {
      if (error.status === 403) {
        return this.errorService.showToast(error?.error?.message);
      }
      this.errorService.handle(error);
    });
  }

  routeToProductDetail(id: number) {
    this.router.navigate(['wardrobe', 'detail', id]);
  }
}
